import React from 'react';

// CD-5196 placeholder: the OPS KPI Power BI/Domo report URL is not confirmed yet.
// When it is, replace the inner div with the iframe (see OpsPBIDashboard.js).
export default function OpsKpiReports() {
  return (
    <div className='contentwrapperiframe bravo-ds'>
      <div className='report-placeholder'>
        <h4>OPS KPI Reports</h4>
        <p>The OPS KPI reports (planned vs actual planning KPIs) will be available here soon.</p>
      </div>
    </div>
  );
}
